import React from 'react';
import { Col } from '@cochlear-design-system/foundation';
import { SummaryPanel } from '../../../ui/SummaryPanel/SummaryPanel';

export const RightPanel = ({
  config,
  data,
  country,
  labels,
  lang,
  leftData,
  rightData,
  unknownData,
  rcData,
  rcRemoteModuleKey,
  useModuleFederationSR,
  providerRegion,
  patientId,
}) => {
  return (
    <Col xs={8}>
      <SummaryPanel
        config={config}
        data={data}
        country={country}
        labels={labels}
        lang={lang}
        leftData={leftData}
        rightData={rightData}
        unknownData={unknownData}
        rcData={rcData}
        rcRemoteModuleKey={rcRemoteModuleKey}
        useModuleFederationSR={useModuleFederationSR}
        providerRegion={providerRegion}
        patientId={patientId}
      />
    </Col>
  );
};
